import http from "../http-common";

import Expert from "../types/Expert.type";

class ExpertDataService {
  login(data: any) {
    return http.post(`/login`, data);
  }

  getExperts(token: any, archive?: boolean) {
    return http.get(`/experts?archive=${archive}`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  getProgrammeExperts(token: any) {
    return http.get(`/experts/programme`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
  }

  addProgramme(expertId: string, data: any) {
    return http.post(`/programattendance?expertId=${expertId}`, data);
  }

  updateProgramme(expertId: string, id: string, data: any) {
    return http.patch(`/programattendance?expertId=${expertId}&id=${id}`, data);
  }

  deleteProgramme(expertId: string, id: string) {
    return http.delete(`/programattendance?expertId=${expertId}&id=${id}`);
  }

  getClientList() {
    return http.get(`/experts/manoshalateam/contact-list`);
  }
  getMessageHistory(userId: any) {
    return http.get(`/experts/manoshalateam/messages?userId=${userId}`);
  }
  sendMessage(data: any) {
    return http.post(`/experts/manoshalateam/messages`, data);
  }
  getExpertPdf(id: any) {
    return http.get(`/experts/${id}/data/pdf`, {
      responseType: "blob",
    });
  }
  getCalenderInfo(id: any) {
    return http.get(`/experts/${id}/calender/timings`);
  }
  postCalenderInfo(id: any, timing: any) {
    return http.post(`/experts/${id}/calender/timings`, timing);
  }
  deleteCalenderInfo(id: any, day: any) {
    return http.delete(`/experts/${id}/calender/timings?day=${day}`);
  }
  getCalenderLeaveInfo(id: any) {
    return http.get(`/experts/${id}/calender/leaves`);
  }
  postCalenderLeaveInfo(id: any, timing: any) {
    return http.post(`/experts/${id}/calender/leaves`, timing);
  }
  deleteCalenderLeaveInfo(id: any, date: any) {
    return http.delete(`/experts/${id}/calender/leaves?date=${date}`);
  }
  getSingleExpert(id: any) {
    return http.get(`/experts/${id}`);
  }

  create(data: Expert) {
    return http.post("/experts", data);
  }

  update(data: Expert, id: any) {
    return http.patch(`/experts/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/experts/${id}`);
  }

  migrateExpertsData() {
    return http.get(`/migrate-expert-data`);
  }

  addPricesToExpert(id: any, data: any) {
    return http.post(`/experts/${id}/price`, data);
  }

  updatePricesToExpert(id: any, priceId: any, data: any) {
    return http.patch(`/experts/${id}/price/${priceId}`, data);
  }

  deletePricesToExpert(id: any, priceId: any) {
    return http.delete(`/experts/${id}/price/${priceId}`);
  }

  updateExpertBillingMonth(id: any, data: any) {
    return http.patch(`/experts/${id}/billing-month`, data);
  }

  getExpertBillingPdf(id: any, month: any, year: any) {
    return http.get(
      `/experts/${id}/billingsummary/download?month=${month}&year=${year}`,
      {
        headers: {
          "Content-Type": "application/pdf",
        },
        responseType: "blob",
      }
    );
  }

  updateArchiveStatus(id: any, archive: any) {
    return http.post(`/expert/update/archive`, { id, archive });
  }

  sendCalendarSyncEmail(email: any) {
    return http.get(`/auth/google?email=${email}`);
  }
  
  getGoogleCalendarEvents(email: any) {
    return http.get(
      `/auth/google/events?email=${email}`
    );
  }

  getTreatmentPlan(expertId: any, userId: any, userEmail: any) {
    return http.get(
      `/experts/treatmentplan?expertId=${expertId}&userId=${userId}&userEmail=${userEmail}`
    );
  }

  getAllTreatmentPlan(expertId: any, userEmail: any) {
    return http.get(
      `/experts/treatmentplan/all?expertId=${expertId}&userEmail=${userEmail}`
    );
  }
}
export default new ExpertDataService();
